<script lang="ts">
export default {
  name: 'UIInput',
};

const inputVariants = cva(
  'flex w-full rounded-md border border-input bg-background ring-offset-background file:border-0 file:bg-transparent file:text-sm file:font-medium file:text-foreground placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-offset-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      size: {
        default: 'h-10 px-3 py-2 text-base md:text-sm',
        sm: 'h-8 px-2 py-1 text-xs',
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
);

export type InputVariants = VariantProps<typeof inputVariants>;
</script>

<script setup lang="ts">

import { computed } from 'vue'
import { cva, type VariantProps } from 'class-variance-authority'
import { cn } from '@/lib/utils'

interface Props {
  class?: string
  type?: string
  modelValue?: string | number
  size?: InputVariants['size']
}

const props = withDefaults(defineProps<Props>(), {
  type: 'text'
})

defineEmits<{
  'update:modelValue': [value: string]
}>()

const inputClass = computed(() =>
  cn(inputVariants({ size: props.size }), props.class)
)
</script>

<template>
  <input
    :type="type"
    :class="inputClass"
    :value="modelValue"
    @input="$emit('update:modelValue', ($event.target as HTMLInputElement).value)"
    v-bind="$attrs"
  />
</template>
